import { Dialog, DialogTitle, DialogContent, DialogActions, Button, DialogContentText, IconButton } from '@mui/material'
import { CloseRounded } from '@mui/icons-material'

export default function CancelPerspectiveDialog({ open, onClose, onSubmit }) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                Confirm
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: 'inherit',
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRounded />
                </IconButton>
            </DialogTitle>

            <DialogContent>Confirm the Cancellation of Perspective Layout by clicking on Submit button</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="contained" onClick={onSubmit}>
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    )
}
